import { PropsWithChildren } from "react";

import { HeaderSlot } from "./ui/HeaderSlot";

import classes from "./Header.module.css";

type Props = PropsWithChildren;

export const Header = ({ children }: Props) => {
  return <header className={classes.header}>{children}</header>;
};

Header.Slot = HeaderSlot;
